// ─── Plan Feature Flags ────────────────────────────────────────────────────
// Feature keys armazenadas em `plans.features` (jsonb string[]).
// Não há atribuição automática a planos — o admin escolhe via UI quais
// planos liberam cada feature.

export const FEATURE_AI_EMAIL_ASSISTANT = "ai_email_assistant";
export const FEATURE_COPILOT_CALL = "copilot_call";
export const FEATURE_ASSISTANT_CHAT = "assistant_chat";

export const ALL_PLAN_FEATURES = [
  FEATURE_AI_EMAIL_ASSISTANT,
  FEATURE_COPILOT_CALL,
  FEATURE_ASSISTANT_CHAT,
] as const;

export type PlanFeature = (typeof ALL_PLAN_FEATURES)[number];

export const PLAN_FEATURE_LABELS: Record<PlanFeature, { label: string; description: string }> = {
  [FEATURE_AI_EMAIL_ASSISTANT]: {
    label: "Assistente IA de E-mail (LeadCopy)",
    description: "Habilita o assistente conversacional LeadCopy para gerar e iterar copy de e-mails e fluxos.",
  },
  [FEATURE_COPILOT_CALL]: {
    label: "Copiloto de call ao vivo",
    description: "Extensão do Chrome que transcreve a reunião e sugere o script do playbook ao vendedor em tempo real.",
  },
  [FEATURE_ASSISTANT_CHAT]: {
    label: "Assistente (chat que comanda o painel)",
    description: "Chat com voz e anexos que executa ações no sistema (contatos, CRM, campanhas, fluxos) e ensina a usar cada tela.",
  },
};

/**
 * Verifica se um plano (lista de features) habilita uma feature específica.
 * Retorna false se features for null/undefined (plano antigo sem features migradas).
 */
export function planHasFeature(features: string[] | null | undefined, feature: PlanFeature): boolean {
  if (!features) return false;
  return features.includes(feature);
}
